import React, { useState, useEffect } from 'react';
import { getApiBase } from '../utils/getApiBase';

export default function LoginForm({ onLoginSuccess }) {
    // 🔹 Inicjalizuj domyślnego admina przy każdym załadowaniu (sprawdza czy istnieje i czy ma hasło)
    useEffect(() => {
        const initDefaultAdmin = async () => {
            try {
                // Najpierw sprawdź status
                const statusResponse = await fetch(`${getApiBase()}/api/initDefaultAdmin`, {
                    method: 'GET',
                });
                
                if (statusResponse.ok) {
                    const status = await statusResponse.json();
                    console.log('🔍 [LoginForm] Status initDefaultAdmin:', status);
                    
                    // WAŻNE: Jeśli istnieje jakikolwiek super admin, NIE WYWOŁUJ initDefaultAdmin
                    // To zapobiega nadpisywaniu zmienionych danych
                    if (!status.hasAnySuperAdmin) {
                        // Tylko jeśli nie ma żadnego super admina, utwórz domyślnego
                        console.log('🔄 [LoginForm] Brak super admina - tworzę domyślnego');
                        const response = await fetch(`${getApiBase()}/api/initDefaultAdmin`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ forceReset: false }),
                        });
                        const result = await response.json();
                        console.log('✅ [LoginForm] initDefaultAdmin result:', result);
                    } else {
                        console.log('✅ [LoginForm] Super admin już istnieje - pomijam initDefaultAdmin');
                    }
                    // Jeśli admin istnieje i ma hasło, nie rób nic - pozwól używać zmienionych danych
                }
            } catch (error) {
                console.error('Błąd inicjalizacji domyślnego admina:', error);
                // Nie blokuj logowania jeśli inicjalizacja się nie powiodła
            }
        };
        initDefaultAdmin();
    }, []);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await fetch(`${getApiBase()}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ login, password }),
            });

            if (!response.ok) {
                let errorMessage = 'Błąd logowania';
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.error || errorMessage;
                } catch {
                    errorMessage = `Błąd serwera (${response.status})`;
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();

            if (data.success && data.user) {
                // Zapisz dane użytkownika w localStorage
                localStorage.setItem('user', JSON.stringify(data.user));
                localStorage.setItem('userType', data.user.isSuperAdmin ? 'superAdmin' : data.user.isAdmin ? 'admin' : 'user');
                
                // Wywołaj callback
                onLoginSuccess(data.user);
            } else {
                throw new Error('Nieprawidłowa odpowiedź serwera');
            }
        } catch (err) {
            setError(err.message || 'Wystąpił błąd podczas logowania');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-900 text-white">
            <div className="w-full max-w-md p-8 bg-gray-800 rounded-lg shadow-lg">
                <h2 className="mb-6 text-2xl font-bold text-center">🔒 Zaloguj się</h2>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="login" className="block mb-2 text-sm font-medium">
                            Login
                        </label>
                        <input
                            id="login"
                            type="text"
                            placeholder="login"
                            value={login}
                            onChange={(e) => setLogin(e.target.value)}
                            required
                            className="w-full p-3 rounded bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            disabled={loading}
                        />
                    </div>

                    <div>
                        <label htmlFor="password" className="block mb-2 text-sm font-medium">
                            Hasło
                        </label>
                        <input
                            id="password"
                            type="password"
                            placeholder="Hasło"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full p-3 rounded bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            disabled={loading}
                        />
                    </div>

                    {error && (
                        <div className="p-3 text-sm text-red-400 bg-red-900/30 border border-red-700 rounded">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full px-4 py-3 bg-blue-600 rounded hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
                    >
                        {loading ? 'Logowanie...' : 'Zaloguj'}
                    </button>
                </form>
            </div>
        </div>
    );
}

